import { request } from "../api";
import { unwrapList } from "./devices";

export interface AuditLogRow {
  id: number;
  action: string;
  actor_type: string;
  actor_id: string | null;
  actor_label: string;
  target_type: string;
  target_id: string | null;
  payload_summary: Record<string, unknown>;
  ip: string | null;
  user_agent: string;
  created_at: string;
}

export interface AuditFilters {
  action?: string;
  actor_type?: string;
  actor_id?: string;
  target_type?: string;
  target_id?: string;
  date_from?: string;
  date_to?: string;
  search?: string;
  limit?: number;
  offset?: number;
}

export type AuditGroupDimension = "actor" | "target";

export interface AuditGroupActorRow {
  actor_type: string;
  actor_id: string | null;
  actor_label: string;
  count: number;
  last_at: string;
}

export interface AuditGroupTargetRow {
  target_type: string;
  target_id: string | null;
  target_label: string;
  count: number;
  last_at: string;
}

export type AuditGroupRow = AuditGroupActorRow | AuditGroupTargetRow;

function qs(params: object): string {
  const sp = new URLSearchParams();
  for (const [k, v] of Object.entries(params) as [string, unknown][]) {
    if (v === undefined || v === "" || v === null) continue;
    sp.append(k, String(v));
  }
  const s = sp.toString();
  return s ? `?${s}` : "";
}

interface Paginated<T> {
  count?: number;
  next?: string | null;
  previous?: string | null;
  results?: T[];
}

export const auditApi = {
  list: async (filters: AuditFilters = {}) => {
    const data = await request<Paginated<AuditLogRow> | AuditLogRow[]>(
      `/api/admin/v1/audit-logs/${qs(filters)}`,
    );
    return unwrapList(data);
  },
  groupByActor: async (filters: AuditFilters = {}) => {
    const data = await request<Paginated<AuditGroupActorRow> | AuditGroupActorRow[]>(
      `/api/admin/v1/audit-logs/group-by/${qs({ ...filters, dimension: "actor" })}`,
    );
    return unwrapList(data);
  },
  groupByTarget: async (filters: AuditFilters = {}) => {
    const data = await request<Paginated<AuditGroupTargetRow> | AuditGroupTargetRow[]>(
      `/api/admin/v1/audit-logs/group-by/${qs({ ...filters, dimension: "target" })}`,
    );
    return unwrapList(data);
  },
};
